import { RefDataType } from 'scenes/common/types';

// Filters out any option with flagname set where that flagname
// does not equal cover type. Effectively, this filters out the 'Don't know'
// build year option for any cover type except 'Contents'.
export const buildYearsByCoverType = (
  buildYears: RefDataType[],
  covertype: string
) =>
  buildYears.filter(
    (yearOption) => !yearOption.flagname || yearOption.flagname === covertype
  );
